import React from 'react';

// Importa o dashboard do WhatsApp
const WaDashboardPage = React.lazy(() => import('./WaDashboardPage'));

export default function WaDashboardWrapper() {
  return (
    <React.Suspense
      fallback={<div className="flex h-64 items-center justify-center">Carregando...</div>}
    >
      <WaDashboardPage />
    </React.Suspense>
  );
}
